/**
 * Module dependencies.
 */

import { authRequest, handleRequestError } from 'src/core/utils/requests';
import { getAuthApiEndpoint } from 'src/core/utils/api-url-resolver';

/**
 * Endpoints.
 */

const authUserEndpoint = getAuthApiEndpoint('createUser');
const authTokenEndpoint = getAuthApiEndpoint('createToken');

/**
 * Export `FormData` type.
 */

export type FormData = {
  email: string;
  info?: {
    [key: string]: string | boolean;
  };
  password: string;
};

/**
 * Export `createUser`.
 */

export async function createUser(formData: FormData) {
  const { email, password } = formData;

  return await authRequest
    .post(authUserEndpoint, formData)
    .then(async () => {
      try {
        const { data } = await authRequest.post(authTokenEndpoint, {
          email,
          password
        });

        return data?.data;
      } catch (error) {
        throw handleRequestError(error);
      }
    })
    .catch(error => {
      throw handleRequestError(error);
    });
}
